export enum LoginActionState {
  MAGIC_LINK = 'MAGIC_LINK',
  SAML_REDIRECT = 'SAML_REDIRECT'
}

// This is the ActorType enum that differentiates between the kinds actors making MCP requests
export enum ActorType {
  USER = 'USER',
  AGENT = 'AGENT'
}
